"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolDestination = void 0;
var tslib_1 = require("tslib");
var string_1 = require("@devexpress/utils/lib/utils/string");
var character_property_descriptor_1 = require("../../../../core/model/character/character-property-descriptor");
var destination_1 = require("../destination");
var SymbolDestination = (function (_super) {
    tslib_1.__extends(SymbolDestination, _super);
    function SymbolDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SymbolDestination.prototype, "elementHandlerTable", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    SymbolDestination.prototype.processElementOpen = function (reader) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fontName, code, charCode, symbol, characterFormatting, prevFormatting, fontInfo;
            return tslib_1.__generator(this, function (_b) {
                fontName = reader.getAttributeNS('font', this.data.constants.wordProcessingNamespaceConst);
                code = reader.getAttributeNS('char', this.data.constants.wordProcessingNamespaceConst);
                if (string_1.StringUtils.isNullOrEmpty(fontName) || string_1.StringUtils.isNullOrEmpty(code))
                    return [2];
                charCode = parseInt(code, 16);
                if (isNaN(charCode))
                    return [2];
                symbol = String.fromCharCode(charCode);
                characterFormatting = this.data.subDocumentInfo.characterImporter.properties;
                prevFormatting = characterFormatting.clone();
                fontInfo = (_a = this.documentModel.cache.fontInfoCache.getItemByName(fontName)) !== null && _a !== void 0 ? _a : this.documentModel.cache.fontInfoCache.addFont(fontName);
                characterFormatting.setValue(character_property_descriptor_1.CharacterPropertyDescriptor.fontInfo, fontInfo);
                this.data.subDocumentInfo.characterImporter.insertText(symbol);
                this.data.subDocumentInfo.characterImporter.resetProperties();
                this.data.subDocumentInfo.characterImporter.properties.copyFrom(prevFormatting);
                return [2];
            });
        });
    };
    return SymbolDestination;
}(destination_1.ElementDestination));
exports.SymbolDestination = SymbolDestination;
